/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import {withTranslation} from 'react-i18next';
import {Grid, Card, CardContent, Typography, CardActions } from '@material-ui/core';

import {IconButton} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import {useThemeData} from '../../context/ThemeDataContext'

function CartSummary(props) {
    const {background_color_7, background_color_4, cart_header_text} = useThemeData().themeData.site.theme;
    const dataCart = props.dataCart;

    return (
        <Grid item lg={4} sm={4} xs={12}>
            <Card className={`card-summary col-lg-4 col-xs-12 col-md-12`}
            >
                <CardContent className="row border-bottom-small" style={{
                    backgroundColor: `${background_color_7}`,
                    borderColor: `${background_color_4}`,
                    color: `${cart_header_text}`
                }}>
                    <Typography variant="h6" align="left"
                        className="col-12 subtitle">{props.t('shoppingcart:Order Summary')}</Typography>
                </CardContent>
                <CardActions className="row border-bottom-small" style={{
                    borderColor: `${background_color_4}`
                }}>
                    <Grid
                        container
                        direction="row"
                        className={`product_body`}
                    >
                        <Grid item lg={5} sm={5} xs={5} className="text-start" style={{ whiteSpace: 'nowrap' }}>
                            <Typography className="row font-bold no-margin-bttm">
                                {props.t('shoppingcart:Order Subtotal')}
                            </Typography>
                            <Typography className="row font-bold small-text">
                                {props.t('shoppingcart:Tax')}
                            </Typography>
                            {dataCart.shoppingcart.discount !== '0,00' &&
                            <Typography
                                className={`row font-bold ${dataCart.shoppingcart.discount_code && 'no-margin-bttm'}`}>
                                {props.t('shoppingcart:Discount')}
                            </Typography>
                            }
                            {dataCart.shoppingcart.discount_code &&
                            <Typography className="row font-bold small-text">
                                {props.t('shoppingcart:Discountcode')}
                            </Typography>
                            }
                            {/*{dataCart.shoppingcart.shippingcost_type}*/}
                            {dataCart.shoppingcart.shippingcost_type === 'afhalen' ? (
                                    <></>
                                    ) : (
                                    dataCart.shoppingcart.shippingcost !== '0,00' &&
                                        <Typography className="row font-bold">
                                            {props.t('shoppingcart:Shipping and handling')}
                                        </Typography>
                                )
                            }

                            {dataCart.shoppingcart.administrationcosts !== '0,00' &&
                            <Typography className="row font-bold">
                                {props.t('shoppingcart:Administrationcosts')}
                            </Typography>
                            }
                        </Grid>
                        <Grid item lg={7} sm={7} xs={7}>
                            <Typography className="row no-margin-bttm" align="right">
                                € {dataCart.shoppingcart.subtotaal}
                            </Typography>
                            <Typography className="row small-text" align="right">
                                € {dataCart.shoppingcart.tax}
                            </Typography>
                            {dataCart.shoppingcart.discount !== '0,00' &&
                            <Typography className={`row ${dataCart.shoppingcart.discount_code && 'no-margin-bttm'}`} align="right">
                                € {dataCart.shoppingcart.discount}
                            </Typography>
                            }
                            {dataCart.shoppingcart.discount_code &&
                                <Typography className="row small-text" align="right">
                                    <IconButton style={{maxHeight: "0vh"}}
                                                onClick={(e) => props.handleDiscountDeletion(e, dataCart.shoppingcart.id)}>
                                        <DeleteIcon/>
                                    </IconButton>
                                    {dataCart.shoppingcart.discount_code}
                                </Typography>
                            }
                            {dataCart.shoppingcart.shippingcost_type === 'afhalen' ? (
                            <></>
                            ) : (
                                dataCart.shoppingcart.shippingcost !== '0,00' &&
                                <Typography className="row" align="right">
                                    € {dataCart.shoppingcart.shippingcost}
                                </Typography>
                            )
                            }
                            {dataCart.shoppingcart.administrationcosts !== '0,00' &&
                            <Typography className="row" align="right">
                                € {dataCart.shoppingcart.administrationcosts}
                            </Typography>
                            }
                        </Grid>
                    </Grid>
                </CardActions>
                {/*<div style={{*/}
                {/*  backgroundColor: `${background_color_7}`,*/}
                {/*}} className="row">*/}
                <CardContent className="row border-bottom-small">
                    <Grid
                        container
                        direction="row"
                        className={`product_body`}
                    >
                        <Grid item lg={8} sm={6} xs={6}>
                            <Typography align="left"
                                className="row font-bold small-text">{props.t('shoppingcart:Total')}: </Typography>
                        </Grid>
                        <Grid item lg={4} sm={6} xs={6}>
                            <Typography
                                className="font-bold col col-lg-9 col-sm-9 col-xs-9 no-padding-left" align="right">€ {dataCart.shoppingcart.totaal}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                {/*</div>*/}
            </Card>
        </Grid>
    );

}

export default React.memo(withTranslation('shoppingcart')(CartSummary));
